import { useState, useEffect, RefObject } from 'react';

export default function useOutsideClick(refs: RefObject<HTMLElement | null>[], callback: () => void) {
  const [clickedInContainer, setClickedInContainer] = useState(false);

  function isDescendantOfRoot(target: EventTarget | null) {
    return refs
      .filter((container) => !!container.current)
      .some((ref) => target instanceof Node && ref.current?.contains(target));
  }

  // Use mousedown/mouseup to enforce that clicks remain outside the root's
  // descendant tree, even when dragged. This should also get triggered on
  // touch devices.
  useEffect(() => {
    function handleMouseDown(e: MouseEvent) {
      setClickedInContainer(isDescendantOfRoot(e.target));
    }

    function handleMouseUp(e: MouseEvent) {
      if (!isDescendantOfRoot(e.target) && !clickedInContainer) callback();
    }

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [refs, callback]);
}
